module.exports = __webpack_public_path__ + "media/images/suppliers/immunostep-5d8b1343f6d79563c94ae028713aa27a.png";